// extracted by mini-css-extract-plugin
export default {"root":"CategoryList_root__MPZM3","titleContainer":"CategoryList_titleContainer__qjZV0"};